var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / View") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-View",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(7.000000, 10.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12 C3.06307289,12 0.152766753,6.46153846 0.0415050488,6.20653846 C-0.0138350163,6.05693183 -0.0138350163,5.89460663 0.0415050488,5.745 C0.152766753,5.53846154 3.06307289,0 9.5,0 C15.9369271,0 18.8472332,5.53846154 18.958495,5.79346154 C19.013835,5.94306817 19.013835,6.10539337 18.958495,6.255 C18.8472332,6.46153846 15.9369271,12 9.5,12 Z",
    id: "6912a2de-4b2f-4be4-a6f8-6996f9d1e9f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,9.2307992 C8.08423322,9.2307992 6.80787195,8.44361758 6.26608146,7.23636186 C5.72429096,6.02910614 6.02376761,4.63949469 7.0248659,3.71550117 C8.0259642,2.79150764 9.53153497,2.51509674 10.8395329,3.01515843 C12.1475309,3.51522013 13.0004007,4.69327582 13.0004007,6 C13.0043779,6.85798248 12.636878,7.68189333 11.9795604,8.2885842 C11.3222428,8.89527508 10.4295788,9.23447014 9.5,9.2307992 L9.5,9.2307992 Z",
    id: "f8a4c271-6901-4a56-ba85-ea4dbe37ea73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.0700e89b28f7476f232e8b466bc15219.svg";
export { ForwardRef as ReactComponent };